function ViewerError(errorCode) {
	let errorMsg;
	if(errorCode == 'COFILE_VERSION_INFO_EMPTY') {
		errorMsg = "파일 버전 정보 없음";
	}else if(errorCode == 'COFILE_PAPER_INFO_EMPTY') {
		errorMsg = "보드 정보 조회 실패";
	}else if(errorCode == 'COFILE_FILE_INFO_EMPTY') {
		errorMsg = "파일 정보 조회 실패";
	}else if(errorCode == 'COFILE_COGROUP_INFO_EMPTY') {
		errorMsg = "협업공간 정보 없음";
	}else if(errorCode == 'COFILE_IMAGE_CONVERSION_FAIL') {
		errorMsg = "이미지 변환 실패 혹은 imageKey == null";
	}else if(errorCode == 'COFILE_FILE_FORMAT_NOT_SUPPORTED') {
		errorMsg = "변환할 수 없는 파일 형식 && 프론트에서 또 처리함";
	}else if(errorCode == 'COFILE_GET_FILE_LIST_FAIL') {
		errorMsg = "파일 목록 조회 실패";
	}else if(errorCode == 'COFILE_FOLDER_INFO_EMPTY') {
		errorMsg = "폴더 정보 없음";
	}else if(errorCode == 'COFILE_FILE_UPLOAD_FAIL') {
		errorMsg = "파일 업로드 실패";
	}else if(errorCode == 'COFILE_FILE_COPY_DENIED') {
		errorMsg = "파일 복사 거부";
	}else if(errorCode == 'COFILE_FILE_COPY_FAIL') {
		errorMsg = "파일 복사 실패";
	}else if(errorCode == 'COFILE_FILE_DELETE_FAIL') {
		errorMsg = "파일 삭제 실패";
	}else if(errorCode == 'COFILE_FILE_SHARE_FAIL') {
		errorMsg = "파일 공유 실패";
	}else if(errorCode == 'COFILE_SITE_USAGE_INFO_EMPTY') {
		errorMsg = "쉐어포인트 사이트 사용량 정보 없음";
	}else if(errorCode == 'COFILE_STORAGE_CAPACITY_EXCEEDED') {
		errorMsg = "파일 저장 용량 초과";
	}else if(errorCode == 'COFILE_FILE_NOT_AUTHORIZED') {
		errorMsg = "권한 없음";
	}else if(errorCode == 'COFILE_VERSION_RESTORE_FAIL') {
		errorMsg = "버전 복원 실패";
	}else if(errorCode == 'COFILE_LATEST_VERSION_RESTORE_DENIED') {
		errorMsg = "파일 최신버전이어서 복원 불가 && 이건 내가 프론트에서 막음";
	}else if(errorCode == 'COFILE_FILE_COPY_COMPLETED_NOT_PERPECTLY') {
		errorMsg = "파일 복사가 완벽하지 않음";
	}else if(errorCode == 'COFILE_FOLDER_COPY_COMPLETED_NOT_PERPECTLY') {
		errorMsg = "파일 복사가 완벽하지 않음";
	}else if(errorCode == 'COFILE_FILE_DELETE_FAIL_LOCKED') {
		errorMsg = "파일 수정중입니다.";
	}

	return alert(errorMsg);
}

export { ViewerError };


// WEBPACK FOOTER //
// ./src/components/cowork/general/file/error/ViewerError.js